// extracted by mini-css-extract-plugin
export var buttonContainer = "featuresList-module--buttonContainer--fa647";
export var dark = "featuresList-module--dark--4ed5f";
export var featuresBody = "featuresList-module--featuresBody--e0c0e";
export var featuresHeader = "featuresList-module--featuresHeader--ab44b";
export var featuresHeadline = "featuresList-module--featuresHeadline--a24d2";
export var featuresList = "featuresList-module--featuresList--fff98";
export var light = "featuresList-module--light--135c0";